<template>
  <AppLayout>
    <AppTitle :title="tt('summary.title')" />
    <Card>
      <Empty v-if="!hasTenants">
        <template #description>
          {{ tt('summary.noTenants') }}
        </template>
        <Button
          :type="EButtonType.primary"
          :title="tt('summary.action.addTenant')"
          style="display: flex;margin: 0 auto;"
          @click="handleTenantAdd"
        />
      </Empty>
    </Card>
    <AddTenantDrawer
      v-if="isAddTenantDrawerOpened"
      visible
      @close="handleAddTenantDrawerClose"
      @success="handleAddTenantSuccess"
    />
  </AppLayout>
</template>

<script lang="ts">
import { Card, Empty } from 'ant-design-vue';
import {
  computed,
  defineComponent,
  onMounted,
  ref,
} from 'vue';

import { Button } from '@/ui';
import { notification } from '@/utils';
import AddTenantDrawer from '@/contexts/accountingContext/components/AddTenantDrawer/index.vue';
import tt from '@/i18n/utils/translateText';
import redirectToInitialRoute from '@/domains/redirectToInitialRoute';
import { EButtonType } from '@/ui/types';
import { useTenantsStore } from '@/stores/tenants';

export default defineComponent({
  name: 'SummaryView',
  components: {
    Card,
    Empty,
    Button,
    AddTenantDrawer,
  },
  setup() {
    const tenantsStore = useTenantsStore();
    const hasTenants = computed(() => !!tenantsStore.userTenants?.length);
    const isAddTenantDrawerOpened = ref(false);

    const handleTenantAdd = () => {
      isAddTenantDrawerOpened.value = true;
    };

    const handleAddTenantDrawerClose = () => {
      isAddTenantDrawerOpened.value = false;
    };

    const handleAddTenantSuccess = () => {
      handleAddTenantDrawerClose();
      notification.success({ message: tt('summary.notification.success.tenantAdded') });
      // если пользователь новый и тенантов раньше не было, редиректим на созданного тенанта
      if (tenantsStore.userTenants?.length === 1) {
        redirectToInitialRoute();
      }
    };

    onMounted(() => {
      if (!tenantsStore.isTenantsLoading && !hasTenants.value) {
        isAddTenantDrawerOpened.value = true;
      }
    });

    return {
      EButtonType,
      isAddTenantDrawerOpened,

      hasTenants,

      handleTenantAdd,
      handleAddTenantDrawerClose,
      handleAddTenantSuccess,
      tt,
    };
  },
});
</script>
